import React from "react";
import { View, Pressable } from "react-native";
import { Text } from "../Text";
import { numericKeypadStyles as styles } from "./styles";

const DIGIT_ROWS = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
];

interface NumericKeypadProps {
  onDigitPress: (digit: string) => void;
  onDeletePress: () => void;
  deleteLabel: string;
}

const NumericKeypad: React.FC<NumericKeypadProps> = ({
  onDigitPress,
  onDeletePress,
  deleteLabel,
}) => {
  const renderDigit = (digit: string) => (
    <Pressable
      key={digit}
      testID={`keypadKey-${digit}`}
      accessibilityRole="button"
      accessibilityLabel={digit}
      onPress={() => onDigitPress(digit)}
      style={styles.key}
    >
      <Text style={styles.keyText}>{digit}</Text>
    </Pressable>
  );

  return (
    <View testID="numericKeypad" style={styles.container}>
      {DIGIT_ROWS.map((row) => (
        <View key={row.join("")} style={styles.row}>
          {row.map(renderDigit)}
        </View>
      ))}
      <View style={styles.row}>
        <View style={styles.emptyKey} />
        {renderDigit("0")}
        <Pressable
          testID="keypadKey-delete"
          accessibilityRole="button"
          accessibilityLabel={deleteLabel}
          onPress={onDeletePress}
          style={styles.key}
        >
          <Text style={styles.keyText}>⌫</Text>
        </Pressable>
      </View>
    </View>
  );
};

export default NumericKeypad;
